import { NewPasswordCardPropertiesType } from "@website/widget/login/components/new-password-card/new-password-card.types";
import { ResetPasswordVerifyOtpService } from "@website/widget/login/services/reset-password-verify-otp";
import { useCallback, useState } from "react";

export const useNewPasswordCard = (
  properties: NewPasswordCardPropertiesType
) => {
  const { setStep, onEndAuth, userData } = properties;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const onChangePassword = useCallback((value: string) => {
    setPassword(value);
  }, []);

  const onSubmitPassword = useCallback(
    async (_event: React.FormEvent<HTMLFormElement>) => {
      _event.preventDefault();
      if (password) {
        setIsLoading(true);
        setError("");
        const { otp, otpId } = userData;

        if (otp && otpId) {
          ResetPasswordVerifyOtpService({
            code: otp,
            newPassword: password,
            otpId: otpId
          })
            .then(() => {
              setStep("password-change-successful");
            })
            .catch((error) => {
              setError(
                error?.response?.data?.message ||
                  "خطایی رخ داده، دوباره تلاش کنید."
              );
            })
            .finally(() => setIsLoading(false));
        } else {
          setStep("phone-number");
        }
      } else {
        setError("رمز عبور را وارد کنید.");
      }
    },
    [password, setStep, userData]
  );

  const onCloseClick = useCallback(() => {
    onEndAuth?.();
  }, [onEndAuth]);

  const onBackClick = useCallback(() => {
    setStep("otp");
  }, [setStep]);

  return {
    isLoading,
    password,
    onBackClick,
    onCloseClick,
    onChangePassword,
    onSubmitPassword,
    error
  };
};
